import { ValidatorFn } from "@angular/forms";
import { format, isValid, parseISO } from "date-fns";

export function maxDateValidator(maxDate: Date): ValidatorFn {
  return control => {
    const rawValue = control.value as Date | string | undefined;
    if (!rawValue) {
      return null;
    }

    const value = rawValue instanceof Date ? rawValue : parseISO(rawValue);
    if (!isValid(value)) {
      return {
        maxdate: {
          expected: format(maxDate, 'yyyy-MM-dd'),
          actual: 'invalid-date',
        },
      };
    }

    if (value.getTime() < maxDate.getTime()) {
      return null;
    }

    return {
      maxdate: {
        expected: format(maxDate, 'yyyy-MM-dd'),
        actual: format(value, 'yyyy-MM-dd'),
      },
    };
  };
}
